import { render, staticRenderFns } from "./vendorcodes.vue?vue&type=template&id=139a1578"
import script from "./vendorcodes.vue?vue&type=script&lang=js"
export * from "./vendorcodes.vue?vue&type=script&lang=js"
import style0 from "./vendorcodes.vue?vue&type=style&index=0&id=139a1578&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports